import { render, staticRenderFns } from "./goodsGroupList.vue?vue&type=template&id=894dc6f4"
import script from "./goodsGroupList.vue?vue&type=script&lang=js"
export * from "./goodsGroupList.vue?vue&type=script&lang=js"
import style0 from "./goodsGroupList.vue?vue&type=style&index=0&id=894dc6f4&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports